import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "584423b6-0f36-4004-aeec-1284c7a539d1", content: "No filling", options: {} },
  { id: "e4c7a3f9-da91-47dd-be4d-92d0f4cee0a5", content: "Fill only the interior volume", options: {} },
  { id: "5c173e77-3f52-48bb-9833-86181627ff33", content: "Fill only the opening", options: {} },
  {
    id: "b25f91f7-d3c1-4ab1-95dd-b38fad23a4d9",
    content: "Fill both the opening and the interior volume ",
    options: {},
  },
];

export const task: Task = {
  id: "84cb063c-1987-4c21-9be8-47c27da4bc9e",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 1,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["e4c7a3f9-da91-47dd-be4d-92d0f4cee0a5", "5c173e77-3f52-48bb-9833-86181627ff33"],
};
